// A landing page that signs teachers up for one thing records the intent before
// the sign-in dialog opens, so the account it creates, by Google or by email, is
// marked with that page's signup_source. See SignupSourceIntent.

function csrfHeaders() {
  const token = document.querySelector('[name="csrf-token"]')?.content
  return token ? { 'X-CSRF-Token': token } : {}
}

// A failed record must not block signing in, so this never rejects: the dialog
// opens either way, and the account is then an ordinary one.
export async function recordSignupIntent(intentPath) {
  try {
    await fetch(intentPath, { method: 'POST', credentials: 'same-origin', headers: csrfHeaders() })
  } catch (_) {
    // see above
  }
}

// The visitor closed the dialog without signing up. The intent only means "is
// signing up here right now", so it must not outlive that: a teacher who
// registers elsewhere within the hour is an ordinary teacher.
export async function clearSignupIntent(intentPath) {
  try {
    await fetch(intentPath, { method: 'DELETE', credentials: 'same-origin', headers: csrfHeaders() })
  } catch (_) {
    // the cookie expires within the hour regardless
  }
}
